<template>
  <div class="search-container">
    <el-checkbox :value="showOnlySelected" @input="handleChangeShowOnlySelected"
      >แสดงเฉพาะผู้ที่ถูกเลือก</el-checkbox
    >
    <div class="search input-group">
      <span class="input-group-text"><i class="fas fa-search"></i></span>
      <input
        v-model="searchText"
        :placeholder="$t('feature.attendance.search_placeholder')"
        type="text"
        class="form-control"
        @keyup.enter="enterSearch"
      />
    </div>
  </div>
</template>

<script>
import { Checkbox } from "element-ui"

export default {
  name: "AttendanceSearch",
  components: { "el-checkbox": Checkbox },
  props: {
    showOnlySelected: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      searchText: "",
    }
  },
  methods: {
    enterSearch() {
      this.$emit("search", this.searchText)
    },
    handleChangeShowOnlySelected(value) {
      this.$emit("showOnlySelected", value)
    },
  },
}
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;
  padding: 0;

  > .el-checkbox {
    margin-right: 10px;
    margin-bottom: 0;
  }

  > .search {
    padding: 0;
  }

  .input-group-text {
    border-top-left-radius: 10em;
    border-bottom-left-radius: 10em;
    background-color: $white;
  }

  .form-control {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    border-top-right-radius: 10em;
    border-bottom-right-radius: 10em;
    border-left: none;
    padding-left: 0;
    color: #4a4a4a;
  }
}
</style>
